import { product } from 'pro/config/products/MC2';
import styles from '@app/product.module.less';
import { ProdSpecifications } from '@pro/product/ProdSpecifications';
import { GetInTouchEntrance } from '@pro/common/GetInTouchEntrance';
import { ProdTop } from '@pro/product/ProdTop';
import { IPageProps } from '@pro/product/interface';
import { getProdServerSideProps } from '@pro/product/services';
import { getPageConf } from '@pro/product/config';
import { ProdLayout } from '@pro/product/ProdLayout';
import { ProdFeatureTagsV2 } from '@pro/product/ProdFeatureTagsV2';

export default function Page({ spu }: IPageProps) {
    return (
        <ProdLayout spu={spu} product={product}>
            <div className={styles.page}>
                <div className={'bg-linear-gray'}>
                    <ProdTop product={product}/>
                </div>
                <div className={'bg-linear-gray-primary'}>
                    <ProdFeatureTagsV2 product={product}/>
                </div>
                <ProdSpecifications product={product}/>
                <GetInTouchEntrance/>
            </div>
        </ProdLayout>
    )
}

Page.pageConf = getPageConf(product);

export async function getServerSideProps(context) {
    return getProdServerSideProps(context, product.variantId)
}
